.card {
  display: block;
  border: 1px solid #eee;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  background: white;
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.06);
}

.imageWrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #f6f6f6;
}

.image {
  object-fit: cover;
}

.imagePlaceholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f2f2f2, #e9e9e9);
}

.cardBody {
  padding: 10px 12px 12px;
}

.title {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
}

.dimensions {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.75;
}

.type {
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tags {
  display: flex;
  gap: 6px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.tag {
  font-size: 11px;
  padding: 2px 6px;
  background: #f3f3f3;
  border-radius: 999px;
}

@media (max-width: 768px) {
  .card {
    border-radius: 1px;
  }
}
